import {
    Box,
    Grid,
    Paper,
    Typography,
    Button,
    Container
} from "@mui/material";
import {
    Preview as PreviewIcon,
    Save as SaveIcon
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import SideBar from "./SideBar";
import FormBuilder from "./FormBuilder";
import FormLoading from "./FormLoading";
import axiosClient from "../../../../lib/axios";
import { useQuery } from "react-query";
import { IDetalharFormulario, ISpecFormulario } from "../../../../types/api/configuracoes/detalhar-formulario";
import { AxiosResponse } from "axios";
import { FormProvider, useForm } from "react-hook-form";
import { useEffect } from "react";

export default function FormulariosDynDetalhe() {

    const { id } = useParams();

    const { data: formulario, isLoading } = useQuery<AxiosResponse<IDetalharFormulario>>({
        queryKey: ["formulario", id],
        queryFn: () => axiosClient.get(`/configuracoes/detalhar-formulario/${id}`),
        cacheTime: 0,
        retry: false
    });
    const spec = formulario?.data?.spec || [] as ISpecFormulario[];

    const methods = useForm<IFormularioDyn>({
        defaultValues: {
            config: {
                ativar_formulario: false
            },
            formulario: []
        }
    });

    /* const onSubmit = (data: IFormularioDyn) => {
        console.log(data);
    }; */

    useEffect(() => {
        if (formulario?.data) {
            methods.reset({
                config: {
                    ativar_formulario: formulario.data.status === "Ativo"
                },
                formulario: formulario.data.spec || []
            });
        }
    }, [formulario?.data, methods]);

    if (isLoading) {
        return <FormLoading />;
    }

    return (
        <Box sx={{ backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            <Container
                sx={{
                    pt: 3,
                    pb: 3
                }}
            >
                <Grid container spacing={3}>
                    <Grid size={{xs: 12}}>
                        <Paper sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box>
                                    <Typography variant="h5" fontWeight="bold">
                                        {formulario?.data?.nome}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Versão: {Number(formulario?.data?.versao).toFixed(1)}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Button
                                        variant="outlined"
                                        startIcon={<PreviewIcon />}
                                    >
                                        Visualizar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        disabled={!formulario?.data?.edicao}
                                        startIcon={<SaveIcon />}
                                    >
                                        Salvar
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>

                    <FormProvider {...methods}>
                        <Grid size={{xs: 12, md: 3}}>
                            <SideBar
                                possuiEdicao={formulario?.data?.edicao || false}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 9}}>   
                            <FormBuilder
                                spec={spec}
                                possuiEdicao={formulario?.data?.edicao || false}
                            />
                        </Grid>
                    </FormProvider>
                </Grid>
            </Container>
        </Box >
    );
}

interface IFormularioDyn {
    config: {
        ativar_formulario: boolean;
    };
    formulario: ISpecFormulario[];
}